import React, { useEffect, useState } from "react";
import {
  Box,
  Image,
  IconButton,
  Text,
  Spinner,
  useMediaQuery,
} from "@chakra-ui/react";

const FullscreenImageViewer = ({ imageUrl, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);       // for fade effect
  const [shouldRender, setShouldRender] = useState(false);  // controls DOM presence
  const [isLoading, setIsLoading] = useState(true);

  // Detect if screen is in portrait orientation
  const [isPortrait] = useMediaQuery("(orientation: portrait)");

  useEffect(() => {
    if (imageUrl) {
      setShouldRender(true);
      setIsLoading(true);
      setTimeout(() => setIsVisible(true), 10); // small delay to trigger CSS transition
    }
  }, [imageUrl]);

  const handleClose = (e) => {
    e.stopPropagation();
    setIsVisible(false);

    // Wait for the fade-out transition to finish before unmounting
    setTimeout(() => {
      setShouldRender(false);
      onClose(); // this can safely set imageUrl to null
    }, 300); // must match transition duration
  };

  if (!shouldRender) return null;

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      bg={isLoading ? "gray.50" : "rgba(0, 0, 0, 0.9)"}
      zIndex="overlay"
      display="flex"
      alignItems="center"
      justifyContent="center"
      onClick={handleClose}
      opacity={isVisible ? 1 : 0}
      transition="opacity 0.3s ease, background-color 0.3s ease"
      overflow="hidden" // prevent scrollbars
    >
      {isLoading && (
        <Spinner
          size="xl"
          color="black"
          position="absolute"
          thickness="4px"
          speed="0.65s"
          zIndex="overlay"
        />
      )}

      <Image
        src={imageUrl}
        width="100vw"
        height="100vh"
        objectFit={isPortrait ? "cover" : "contain"} // dynamic objectFit based on orientation
        alt="Fullscreen"
        onClick={(e) => e.stopPropagation()}
        onLoad={() => setIsLoading(false)}
        style={{
          opacity: isLoading ? 0 : 1,
          transition: "opacity 0.4s ease",
          display: "block",
        }}
      />

      <IconButton
        icon={<Text fontSize="3xl" color={isPortrait ? "black" : "white"}>×</Text>}
        position="absolute"
        top="20px"
        right="20px"
        size="2xl"
        variant="ghost"
        colorScheme="blackAlpha"
        onClick={handleClose}
        zIndex="overlay"
        aria-label="Close fullscreen"
      />
    </Box>
  );
};

export default FullscreenImageViewer;
